// 组件
import importImg from '@/components/importImg.vue'
import alterForm from '@/components/alterForm'
// 接口
import { purchaseOrdersAdd, purchaseOrdersEdit, getSimpleList, getShopItemStocksByItemIdSimpleList, getShopItemsSimpleList, getPurchaseOrdersEditDetails } from '@/services/suppliers.js'
// 其他
import loading from '@/utils/loading.json'
import jsonData from './jsonData'
import constant from '@/utils/constant.js'
import Utils from '@/utils/Utils'

export default {
  name: 'purChaseEdit',
  components: {
    importImg,
    alterForm
  },
  props: {
    purchase_id: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      constant,
      modifyData: {},
      modifyData_f: {},
      collapseLength: [],
      formData: jsonData.formData,
      visible: true,
      supplier_id: '',
      id: '',
      form: {
        purchase_order_items_attributes: []
      },
      purchase_order_items_attributes_destroy: [],
      options: [],
      shopItems: [],
      loading: false
    }
  },
  watch: {
  },
  created () {
    this.init()
  },
  mounted () {
  },
  methods: {
    init () {
      this.collapseLength = [...new Array(this.formData.length).keys()]
      this.$store.state.app.loading = this.$loading(loading)
      const initRequest1 = getSimpleList().then(res => {
        this.formData[0].createDateItem[0].options = res.data.suppliers
        return res
      }).catch(err => err)
      const requestArr = [initRequest1]
      if (this.$route.name === 'purchaseEdit' || (this.purchase_id && this.disabled && this.$route.name !== 'purchaseAdd')) {
        // 根据supplier_id获取商品
        // 获取详情接口
        this.id = (this.purchase_id && this.disabled) ? this.purchase_id : this.$route.params.id
        if (this.purchase_id && this.disabled && this.$route.name !== 'purchaseAdd') {
          this.handleDisabled(true)
        } else {
          this.formData[0].createDateItem[0].Object.disabled = true
        }
        this.handleAddBtnClick()
        const initRequest2 = getPurchaseOrdersEditDetails(this.id).then(res => {
          const purchase_order = Object.assign({}, res.data.purchase_order)
          if (purchase_order.supplier_deleted) {
            this.formData[0].createDateItem[0].options.push({ id: purchase_order.supplier_id, name: purchase_order.supplier_name })
          }
          this.modifyData = purchase_order
          if (purchase_order.status === 'received') {
            this.formData[0].createDateItem[0].options = [{ id: purchase_order.supplier_id, name: purchase_order.supplier_name }]
            this.options[0].productList = purchase_order.shop_items
            this.options[0].item_stocks = purchase_order.item_stocks
            res.data.purchase_order.purchase_order_items.forEach((item, index) => {
              if (index > 0) {
                this.handleAddBtnClick()
                this.options[index].productList = purchase_order.shop_items
                this.options[index].item_stocks = purchase_order.item_stocks
              }
            })
            this.form.purchase_order_items_attributes = res.data.purchase_order.purchase_order_items
            this.$store.state.app.loading.close()
          } else {
            const shop_item_ids = []
            purchase_order.purchase_order_items.map((item) => {
              shop_item_ids.push(item.shop_item_id)
            })
            getShopItemsSimpleList({
              per_page: 1000,
              shop_item_stocks_supplier_ids_cont: purchase_order.supplier_id,
              shop_item_ids: shop_item_ids
            }).then(shop => {
              this.options[0].productList = shop.data.shop_items
              this.shopItems = shop.data.shop_items
              res.data.purchase_order.purchase_order_items.forEach((item, index) => {
                if (index > 0) {
                  this.handleAddBtnClick()
                }
                this.supplier_id = this.modifyData.supplier_id
                this.handleSelectChange(item.shop_item_id, index, null, item.shop_item_stock_id)
              })
              this.form.purchase_order_items_attributes = res.data.purchase_order.purchase_order_items
              this.$store.state.app.loading.close()
            })
            return res
          }
        }).catch(err => err)
        requestArr.push(initRequest2)
      } else {
        this.handleDisabled(false)
      }
      Promise.all(requestArr).then(res => {

      }).finally(() => {
        if (this.$route.name !== 'purchaseEdit') {
          this.$store.state.app.loading.close()
        }
      })
    },
    handleDisabled (value) {
      this.formData[0].createDateItem.forEach(item => {
        item.Object.disabled = value
      })
    },
    handleChange (data, prop, item) {
      if (prop === 'supplier_id') {
        this.loading = true
        if (this.form.purchase_order_items_attributes.length > 0) {
          this.form.purchase_order_items_attributes = []
          this.options = []
          this.shopItems = []
        }
        getShopItemsSimpleList({ per_page: 1000, shop_item_stocks_supplier_ids_cont: data }).then(res => {
          if (this.options[0] && this.options[0].productList.length === 0) {
            this.options[0].productList = res.data.shop_items
          }
          this.shopItems = res.data.shop_items
          this.supplier_id = data
          this.loading = false
        })
      }
    },
    handleAddFirstArray (createData, alterData, prop) {
    },
    formSubmit (data) {
      this.$refs.mainForm.validate((valid) => {
        if (valid) {
          this.$store.state.app.loading = this.$loading(loading)
          const obj = JSON.parse(JSON.stringify(data))
          const obj_f = Utils.deepCopy(this.form)
          obj_f.purchase_order_items_attributes.forEach(item => {
            delete item.shop_item_id
          })
          if (this.$route.name === 'purchaseEdit' && this.purchase_order_items_attributes_destroy.length > 0) {
            obj_f.purchase_order_items_attributes = obj_f.purchase_order_items_attributes.concat(this.purchase_order_items_attributes_destroy)
          }
          const params = {
            purchase_order: {
              ...obj.data,
              ...obj_f
            }
          }
          const api = this.$route.name === 'purchaseEdit' ? purchaseOrdersEdit : purchaseOrdersAdd
          api(params, this.id).then(res => {
            if (res.status === 200) {
              this.$message({
                type: 'success',
                message: this.$t('message.operateSuccess')
              })
              setTimeout(() => {
                this.$router.push({
                  name: 'purchaseManagerList'
                })
              }, constant.ROUTER_CHANGE_INTERVAL)
            }
          }).finally(() => {
            this.$store.state.app.loading.close()
          })
        } else {
          this.$message.error(this.$t('message.formIsRequire'))
          return false
        }
      })
    },
    handleSelectChange (data, index, name = null, shop_item_stock_id = null) {
      if (name === 'shop_item_stock_id') {
        const stock = this.options[index].item_stocks.filter(item => item.id === data)
        const costPriceArr = stock[0].shop_item_stock_suppliers_attributes.filter(supplier => supplier.supplier_id === this.supplier_id)
        this.$set(this.form.purchase_order_items_attributes[index], 'price', costPriceArr[0].price_f)
        return
      }
      this.$set(this.form.purchase_order_items_attributes[index], 'shop_item_stock_id', '')
      const params = {
        supplier_ids_cont: this.supplier_id,
        shop_item_id_eq: data.id || data
      }
      if (shop_item_stock_id) {
        params.shop_item_stock_id = shop_item_stock_id
      }
      this.options[index].loading = true
      getShopItemStocksByItemIdSimpleList(this.supplier_id, params).then(res => {
        this.options[index].item_stocks = res.data.shop_item_stocks
        this.options[index].loading = false
      })
      // console.log('options')
      // console.log(this.options)
    },
    handleAddBtnClick () {
      this.form.purchase_order_items_attributes.push({
        shop_item_id: '',
        shop_item_stock_id: '',
        quantity: ''
      })
      this.options.push({
        productList: this.shopItems,
        item_stocks: [],
        loading: false
      })
    },
    handleDelBtnClick (item, index) {
      if (item.id) {
        const purchase_item = Object.assign({ _destroy: true }, Utils.deepCopy(this.form.purchase_order_items_attributes[index]))
        delete purchase_item.shop_item_id
        this.purchase_order_items_attributes_destroy.push(purchase_item)
      }
      this.form.purchase_order_items_attributes.splice(index, 1)
      this.options.splice(index, 1)
      this.$forceUpdate()
    },
    handleCancelClick () {
      this.$router.back()
    }
  }
}
